import { EN } from './en'
import { ES } from './es'

export {
  EN,
  ES
}
